var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4783 12H24C24 10.9169 23.8556 9.86771 23.5866 8.86955H11.4783V12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4783 5.73914H22.2387C21.5041 4.54045 20.565 3.48094 19.4699 2.60869H11.4783V5.73914Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C14.8242 24 17.42 23.0239 19.4699 21.3913H4.53014C6.58003 23.0239 9.17582 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76128 18.2609H22.2387C22.8285 17.2986 23.2858 16.2467 23.5866 15.1304H0.413391C0.714188 16.2467 1.17155 17.2986 1.76128 18.2609Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97972 10.2717C6.34087 10.2717 5.01234 8.94314 5.01234 7.30435C5.01234 5.66555 6.34092 4.33697 7.97972 4.33697C8.4907 4.33697 8.9715 4.46621 9.39126 4.69364C8.73276 4.04972 7.8322 3.65222 6.83841 3.65222C4.82142 3.65222 3.18623 5.28736 3.18623 7.30439C3.18623 9.32142 4.82142 10.9566 6.83841 10.9566C7.8322 10.9566 8.73276 10.5591 9.39126 9.91514C8.9715 10.1425 8.49075 10.2717 7.97972 10.2717Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81592 5.21738L9.34275 6.31903L10.5325 6.04416L9.9997 7.14286L10.9565 7.90163L9.76523 8.17017L9.76856 9.39131L8.81592 8.62735L7.86323 9.39131L7.86651 8.17017L6.67523 7.90163L7.63204 7.14286L7.09922 6.04416L8.28904 6.31903L8.81592 5.21738Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.a7acea8c1df06138f8d4daf7343e9d9a.svg";
export { ForwardRef as ReactComponent };